import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ArtiEnvironment, ENVIRONMENT } from '@environments/model';
import { MessageService } from 'primeng/api';
import { Logger } from '../utils';
import { TranslateService } from '@ngx-translate/core';

interface ConsentServiceUrls {
  artifactRepo?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LicenseService {
  private notAcceptedConsentUrls: ConsentServiceUrls = {};
  private logger = new Logger(this.constructor.name);

  constructor(
    private httpClient: HttpClient,
    private messageService: MessageService,
    private translateService: TranslateService,
    @Inject(ENVIRONMENT) private environment: ArtiEnvironment,
  ) {}

  async initLicenses() {
    await this.fetchNotAcceptedConsents();
  }

  getNotAcceptedConsentUrl(serviceId: keyof ConsentServiceUrls): string | undefined {
    return this.notAcceptedConsentUrls[serviceId];
  }

  private async fetchNotAcceptedConsents() {
    if (!this.environment.consentManagement) {
      return;
    }

    try {
      this.notAcceptedConsentUrls = await firstValueFrom(
        this.httpClient.get<ConsentServiceUrls>(this.environment.apiUrl + 'licensing/consents/not-accepted'),
      );
    } catch (error) {
      this.logger.error('Error fetching consents. Details = ', error);
      if (this.environment.consentManagement.ignoreConsentErrors) {
        this.logger.warn('App is configured to ignore consent errors');
        return;
      }

      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('consent.error.summary'),
        detail: this.translateService.instant('consent.error.details'),
        life: 10000,
      });

      throw error;
    }
  }
}
